var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyWsjFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49902 3.75C7.49902 3.33579 7.83481 3 8.24902 3C8.66324 3 8.99902 3.33579 8.99902 3.75C8.99902 5.79651 10.6383 7.46011 12.6753 7.49941C12.6998 7.49907 12.7244 7.4989 12.749 7.4989C13.1632 7.4989 13.499 7.83469 13.499 8.2489L13.499 8.25011C13.499 8.66432 13.1632 9.00012 12.749 9.00012C12.7244 9.00012 12.6998 8.99995 12.6752 8.99961C10.6382 9.03894 8.99902 10.7025 8.99902 12.749C8.99902 13.1632 8.66324 13.499 8.24902 13.499C7.83481 13.499 7.49902 13.1632 7.49902 12.749C7.49902 10.7025 5.85985 9.03897 3.82289 8.99961C3.79831 8.99995 3.77369 9.00012 3.74902 9.00012C3.33481 9.00012 2.99902 8.66434 2.99902 8.25012V8.2489C2.99902 7.83469 3.33481 7.4989 3.74902 7.4989C3.77369 7.4989 3.79831 7.49907 3.82289 7.49941C5.85985 7.46005 7.49902 5.79647 7.49902 3.75Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.25C12 7.83579 12.3358 7.5 12.75 7.5H21.75C22.1642 7.5 22.5 7.83579 22.5 8.25C22.5 8.66421 22.1642 9 21.75 9H12.75C12.3358 9 12 8.66421 12 8.25Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17.499C3 17.0848 3.33579 16.749 3.75 16.749H12C12.4142 16.749 12.75 17.0848 12.75 17.499C12.75 17.9132 12.4142 18.249 12 18.249H3.75C3.33579 18.249 3 17.9132 3 17.499Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.499C18 17.0848 18.3358 16.749 18.75 16.749L21.75 16.749C22.1642 16.749 22.5 17.0848 22.5 17.499C22.5 17.9132 22.1642 18.249 21.75 18.249L18.75 18.249C18.3358 18.249 18 17.9132 18 17.499Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 17.249C11.25 15.178 12.9289 13.499 15 13.499C17.0711 13.499 18.75 15.178 18.75 17.249C18.75 19.3201 17.0711 20.999 15 20.999C12.9289 20.999 11.25 19.3201 11.25 17.249Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWsjFill);
export default __webpack_public_path__ + "static/media/MyWSJ-fill.f994c2e2d87d23517b027a6b129e9b39.svg";
export { ForwardRef as ReactComponent };